export const SET_CQL_FILTER = "SET_CQL_FILTER";

export const setCqlFilterAction = (cqlFilter?: string) => {
    return {
        type: SET_CQL_FILTER,
        cqlFilter: cqlFilter,
    };
};
